// Production means only production, not pre-prod
export const isProduction = process.env.NEXT_PUBLIC_ENVIRONMENT === "production";
